import { render, staticRenderFns } from "./NewCourse.vue?vue&type=template&id=ef0471ca&scoped=true&"
import script from "./NewCourse.vue?vue&type=script&lang=js&"
export * from "./NewCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0471ca",
  null
  
)

export default component.exports